export const backRoutes =[
        {
            path: '/back',
            name: 'back',
            component: () => import('@/views/Back'),
            meta: {
                title: '后台'
            },
            redirect: '/back/system/user',
            children: [
                {
                    path: '/back/system/user',
                    name: 'sysUser',
                    component: () => import('@/views/Back/system/user'),
                    meta: {
                        title: '用户管理'
                    }
                },
                {
                    path: '/back/system/role',
                    name: 'sysRole',
                    component: () => import('@/views/Back/system/role'),
                    meta: {
                        title: '角色管理'
                    }
                },
                {
                    path: '/back/system/tissue',
                    name: 'sysTissue',
                    component: () => import('@/views/Back/system/tissue'),
                    meta: {
                        title: '组织管理'
                    }
                },
                {
                    path: '/back/system/menu',
                    name: 'sysMenu',
                    component: () => import('@/views/Back/system/menu'),
                    meta: {
                        title: '菜单管理'
                    }
                },
                {
                    path: '/back/content/essay',
                    name: 'conEssay',
                    component: () => import('@/views/Back/content/essay'),
                    meta: {
                        title: '文章管理'
                    }
                },
            ]
        }
    ]